/* Elite custom start: preserve an explicit subscription choice when Eurus changes variants. */
(() => {
  if (window.eliteSubscriptionChoiceLoaded) return;
  window.eliteSubscriptionChoiceLoaded = true;
  function init() {
    const block = document.querySelector('.shopify_subscriptions_app_block');
    const root = block?.closest('[id^="ProductInfo-"]');
    if (!root || root.dataset.eliteSubscriptionChoice) return;
    root.dataset.eliteSubscriptionChoice = 'true';
    let chosen = null, restoring = false, queued = false;
    const summary = document.createElement('p');
    summary.className = 'elite-purchase-summary';
    summary.setAttribute('role', 'status');
    summary.style.margin = '0.75rem 0';
    const updateSummary = () => {
      const visibleBlock = Array.from(root.querySelectorAll('.shopify_subscriptions_app_block')).find(el => Array.from(el.querySelectorAll('input[data-radio-type]')).some(input => input.getClientRects().length > 0));
      if (!visibleBlock) return;
      for (const input of visibleBlock.querySelectorAll('input[data-radio-type]')) {
        const monthly = !!input.dataset.sellingPlanId;
        const label = monthly ? 'Deliver monthly' : 'Try it once';
        const span = monthly ? input.closest('label')?.querySelector('.title_and_price_wrapper > span') : input.parentElement.querySelector('span');
        if (span && span.textContent.trim() !== label) span.textContent = label;
        const aria = `${label}. ${monthly ? 'Recurring monthly delivery.' : 'One-time purchase; no automatic renewal.'} Product price ${input.dataset.variantPrice || ''}`;
        if (input.getAttribute('aria-label') !== aria) input.setAttribute('aria-label', aria);
      }

      if (summary.previousElementSibling !== visibleBlock) visibleBlock.after(summary);
      const selected = visibleBlock.querySelector('input[data-radio-type]:checked');
      if (!selected) return;
      const price = selected.dataset.variantPrice || '';
      const recurring = !!selected.dataset.sellingPlanId;
      const text = recurring
        ? `Selected: Deliver monthly${price ? ', ' + price + ' per delivery' : ''}. Automatically renews; skip or cancel.`
        : `Selected: Try it once${price ? ', ' + price : ''}. This order will not renew. Choose “Deliver monthly” for a subscription.`;
      if (summary.textContent !== text) summary.textContent = text;
    };

    root.addEventListener('change', (event) => {
      const input = event.target;
      if (restoring || !input.matches('input[data-radio-type]')) return;
      chosen = input.dataset.sellingPlanId || '';
      requestAnimationFrame(updateSummary);
    });
    const restore = () => {
      queued = false;
      updateSummary();
      if (chosen === null) return;
      const section = Array.from(root.querySelectorAll('.shopify_subscriptions_app_block')).find(el => Array.from(el.querySelectorAll('input[data-radio-type]')).some(input => input.getClientRects().length > 0));
      if (!section) return;
      const input = Array.from(section.querySelectorAll('input[data-radio-type]')).find(el => (el.dataset.sellingPlanId || '') === chosen);
      if (input && !input.checked) {
        restoring = true;
        input.click();
        restoring = false;
      }
    };
    updateSummary();
    new MutationObserver(() => {
      if (!queued) { queued = true; requestAnimationFrame(restore); }
    }).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Elite custom end */
